<template>
    <div>
        <vx-card title="Customer Payment Account">
            <open/>
        </vx-card>
    </div>
</template>
<script>
import open from "./open.vue";

export default {
    components: {
        open,
    },
}
</script>